// SPDX-License-Identifier: Apache-2.0
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Transaction_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionOutput = exports.Transaction = exports.registerTransactionType = void 0;
const api_1 = require("./..");
const api_2 = require("./..");
const ledger_1 = require("../../ledger");
const util_1 = require("../util");
const typedjson_1 = require("../../export/typedjson");
const ethers_1 = require("ethers");
const assets_1 = require("../../ledger/assets");
const transactionImpls = new Map();
const transactionTypeName = "Transaction";
function registerTransactionType(typeName, typeClass) {
    transactionImpls.set(typeName, typeClass);
}
exports.registerTransactionType = registerTransactionType;
/** Transaction is the base class for all transactions. */
let Transaction = Transaction_1 = class Transaction extends api_1.ErdstallObject {
    constructor(sender, nonce) {
        super();
        this.sender = sender;
        this.nonce = nonce;
    }
    async sign(contract, signer) {
        const sig = await signer.signMessage(this.packTagged(contract).keccak256());
        this.sig = new api_2.Signature(sig);
        return this;
    }
    verify(contract) {
        if (!this.sig) {
            return false;
        }
        const rec = ethers_1.utils.verifyMessage(this.packTagged(contract).keccak256(), this.sig.toString());
        return rec === this.sender.toString();
    }
    static fromJSON(js) {
        let data = JSON.stringify(js.data);
        if (!transactionImpls.has(js.type)) {
            throw new Error(`unknown transaction type "${js.type}"`);
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return typedjson_1.TypedJSON.parse(data, transactionImpls.get(js.type));
    }
    packTagged(contract) {
        const enc = new util_1.ABIEncoder(this.sender, ["uint64", this.nonce]);
        return enc.pack(this.encodeABI(enc, contract), contract);
    }
    hash() {
        const toHash = this.packTagged(ledger_1.Address.fromString(assets_1.ETHZERO));
        return ethers_1.utils.keccak256(new Uint8Array([...toHash.bytes, ...this.sig.value]));
    }
    static toJSON(me) {
        return {
            type: me.txTypeName(),
            data: JSON.parse(typedjson_1.TypedJSON.stringify(me, me.txType())),
        };
    }
    objectType() {
        return Transaction_1;
    }
    objectTypeName() {
        return transactionTypeName;
    }
};
__decorate([
    typedjson_1.jsonMember(ledger_1.Address),
    __metadata("design:type", ledger_1.Address)
], Transaction.prototype, "sender", void 0);
__decorate([
    typedjson_1.jsonBigIntMember(),
    __metadata("design:type", typeof BigInt === "function" ? BigInt : Object)
], Transaction.prototype, "nonce", void 0);
__decorate([
    typedjson_1.jsonMember(api_2.Signature),
    __metadata("design:type", api_2.Signature)
], Transaction.prototype, "sig", void 0);
Transaction = Transaction_1 = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [ledger_1.Address, typeof BigInt === "function" ? BigInt : Object])
], Transaction);
exports.Transaction = Transaction;
api_1.registerErdstallType(transactionTypeName, Transaction);
util_1.customJSON(Transaction);
typedjson_1.TypedJSON.mapType(Uint8Array, {
    deserializer: (json) => {
        if (!json) {
            return new Uint8Array();
        }
        return ethers_1.utils.arrayify(json);
    },
    serializer: (value) => (value == null ? value : ethers_1.utils.hexlify(value)),
});
let TransactionOutput = class TransactionOutput {
    constructor(payload) {
        this.payload = payload;
    }
};
__decorate([
    typedjson_1.jsonMember(Uint8Array),
    __metadata("design:type", Uint8Array)
], TransactionOutput.prototype, "payload", void 0);
TransactionOutput = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [Uint8Array])
], TransactionOutput);
exports.TransactionOutput = TransactionOutput;
//# sourceMappingURL=transaction.js.map